import { theme } from '@prophecy/theme';
import styled, { css } from 'styled-components';

import { Stack } from './Stack';
export const Container = styled.div<{ noPadding?: boolean }>`
  width: 100%;
  max-width: 1280px;
  overflow-x: auto;
  height: 100%;
  cursor: default;
  ${({ noPadding }) => (noPadding ? `padding-top: ${theme.outlineWidth};` : `padding: ${theme.spaces.x40};`)}
  @media (max-width: 1280px) {
    max-width: 100%;
    ${({ noPadding }) => (noPadding ? `padding-top: ${theme.outlineWidth};` : `padding: ${theme.spaces.x24};`)}
  }
`;

export const HeaderHeight = '44px';
export const FooterHeight = '30px';
export const CanvasInsetFooterSeparatorHeight = '21px';
export const SIDE_NAVBAR_WIDTH = '50px';
export const ContainerPadding = theme.spaces.x32;
const ContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  overflow: auto;
`;
const Container1 = styled(Stack)`
  width: calc(100% - ${SIDE_NAVBAR_WIDTH});
  min-width: calc(${theme.newBreakpoints.m} - ${SIDE_NAVBAR_WIDTH});
  max-width: calc(${theme.newBreakpoints.xl} - ${SIDE_NAVBAR_WIDTH});
  padding: ${theme.spaces.x40} ${ContainerPadding} ${ContainerPadding};
  margin-left: auto;
  margin-right: auto;
`;
const GridContainer = styled.div<{
  hasFooter: boolean;
  hasHeader: boolean;
  footerHeight?: string;
  background?: string;
}>`
  display: grid;
  overflow: hidden;
  height: 100%;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: ${({ hasHeader }) => (hasHeader ? HeaderHeight : '')} minmax(0, 1fr) ${({
      hasFooter,
      footerHeight
    }) => (hasFooter ? footerHeight || FooterHeight : '')};
  background: ${({ background }) => background ?? theme.colors.gray25};
`;

const FooterRoot = styled.div<{ readonly footerBackground?: string }>`
  background: ${({ footerBackground }) => footerBackground || theme.colors.gray50};
  width: 100%;
  ${({ footerBackground }) => (footerBackground ? `border-top: 1px solid ${theme.colors.gray200}` : '')}
`;
export const HeaderRoot = styled(Stack)<{ $headerEffects?: boolean }>`
  ${({ $headerEffects }) =>
    $headerEffects &&
    css`
      background: ${theme.colors.gray50};
      border: 1px solid ${theme.colors.gray200};
    `}
`;
export function MetadataPageContainer({
  main,
  header,
  footer,
  hasLayoutContainer = true,
  footerBackground,
  background,
  headerEffects = true,
  ...rest
}: {
  main: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  hasLayoutContainer?: boolean;
  footerHeight?: string;
  footerBackground?: string;
  background?: string;
  headerEffects?: boolean;
}) {
  const hasFooter = Boolean(footer);
  const hasHeader = Boolean(header);

  return (
    <GridContainer hasFooter={hasFooter} hasHeader={hasHeader} background={background} {...rest}>
      {hasHeader ? (
        <HeaderRoot
          $headerEffects={headerEffects}
          padding={`${theme.spaces.x6} ${theme.spaces.x12}`}
          direction='horizontal'
          alignY='center'
          align='space-between'
          width='100%'>
          {header}
        </HeaderRoot>
      ) : null}
      {hasLayoutContainer ? (
        <ContainerWrapper>
          <Container1 height='100%'>{main}</Container1>
        </ContainerWrapper>
      ) : (
        main
      )}
      {hasFooter ? <FooterRoot footerBackground={footerBackground}>{footer}</FooterRoot> : null}
    </GridContainer>
  );
}
